import React, { useEffect, useState } from "react";
import Footer from "../components/reusable/footer";
import AppHeader from "../components/reusable/header";
import {
  PriceCardButton,
  PriceCardSection,
  PriceDurationSection,
  PriceHeaderSection,
  PriceInfoSpan,
  PriceMainDiv,
  PricingCard,
} from "../styles/pricing";
import { RiCheckLine } from "react-icons/ri";

const VSPricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isMonthly, setisMonthly] = useState<boolean>(false);

  return (
    <div className="main-widget">
      <PriceMainDiv>
        <AppHeader
          hideContact={false}
          logo={"/images/sixthWhiteIcon.png"}
          top="0.5rem"
          width="10rem"
          mobileWidth="8rem"
        />
        <PriceHeaderSection>
          <div>
            <section className="section">
              <div className="sub_text">
                <p>pricing</p>
              </div>
              <div className="sub_header">
                <h2>Choose a plan that works for you</h2>
              </div>
            </section>
          </div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <img  loading ="lazy" src="/images/herobg.jpeg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </PriceHeaderSection>

        <PriceCardSection $isMonthly={isMonthly}>
          <div className="button_wrap">
            <div onClick={() => setisMonthly(true)}>Monthly</div>
            <div onClick={() => setisMonthly(false)}>Yearly (save 20%)</div>
          </div>
          <div className="price_container">
            {PricingData.map((item, index) => (
              <PricingCard key={index + ""}>
                <div>
                  <h2 className="text"> {item.Plan} </h2>
                  <div>
                    {" "}
                    <span className="price_text">
                      {isMonthly ? item.Price : item.YearPrice}
                    </span>
                    {item.Frequency}{" "}
                  </div>
                </div>

                <PriceDurationSection>
                  {item.benefits.map((benefit, benefitIndex) => (
                    <PriceInfoSpan key={index + ""}>
                      <RiCheckLine />
                      <p>{benefit}</p>
                    </PriceInfoSpan>
                  ))}
                </PriceDurationSection>
                <PriceCardButton onClick={() => window.location.href = "https://app.trysixth.com"}>Get started</PriceCardButton>
              </PricingCard>
            ))}
          </div>
          <div className="price_container">
            {lifetimeData.map((item, index) => (
              <PricingCard key={index + ""}>
                <div>
                  <h2 className="text"> {item.Plan} </h2>
                  <div>
                    {" "}
                    <span className="price_text">{item.Price}</span>
                    {item.Frequency}{" "}
                  </div>
                  <p>{item.brief}</p>
                </div>

                <PriceDurationSection>
                  {item.benefits.map((benefit, benefitIndex) => (
                    <PriceInfoSpan key={index + ""}>
                      <RiCheckLine />
                      <p>{benefit}</p>
                    </PriceInfoSpan>
                  ))}
                </PriceDurationSection>
                <PriceCardButton onClick={() => window.location.href = "https://app.trysixth.com"}>Get lifetime</PriceCardButton>
              </PricingCard>
            ))}
          </div>
          <div className="price_container">
            {teamsData.map((item, index) => (
              <PricingCard key={index + ""}>
                <div>
                  <h2 className="text"> {item.Plan} </h2>
                  <div>
                    {" "}
                    <span className="price_text">
                      {isMonthly ? item.Price : item.YearPrice}
                    </span>
                    {item.Frequency}{" "}
                  </div>
                </div>

                <PriceDurationSection>
                  {item.benefits.map((benefit, benefitIndex) => (
                    <PriceInfoSpan key={index + ""}>
                      <RiCheckLine />
                      <p>{benefit}</p>
                    </PriceInfoSpan>
                  ))}
                </PriceDurationSection>
                <PriceCardButton onClick={() => window.location.href = "https://app.trysixth.com"}>Get started</PriceCardButton>
              </PricingCard>
            ))}
          </div>
        </PriceCardSection>

        <Footer />
      </PriceMainDiv>
    </div>
  );
};

export default VSPricing;

const PricingData = [
  {
    PlanImage: "",
    Plan: "Free",
    PlanColor: "#4FB06D",
    Price: "Free",
    YearPrice: "Free",
    formerYearPrice: "",
    Frequency: "",
    brief: "",
    info: "",
    button: [
      {
        color: "var(--sixthPurple)",
        bg: "transparent",
        text: "install",
        onClick: () => {
          window.open(
            "https://marketplace.visualstudio.com/items?itemName=Sixth.sixth-AI",
            "_blank"
          );
        },
      },
    ],
    benefits: [
      "No credit card required",
      "50 agent/chat requests per month",
      "2,000 completions per month",
      "Claude Sonnet 4.5 + Gemini 3",
      "Limited image generation",
      "MCP, skills, hooks",
    ],
  },
  {
    PlanImage: "",
    Plan: "Pro",
    PlanColor: "#4FB06D",
    Price: "$10",
    Frequency: "/Month",
    brief: "",
    YearPrice: "$8",
    formerYearPrice: "$20",
    button: [
      {
        color: "var(--sixth-white)",
        bg: "var(--sixth-gradient3)",
        text: "get started",
        onClick: () => {
          window.location.href = "https://app.trysixth.com";
        },
      },
    ],
    benefits: [
      "Extended limits on Agent",
      "Access to frontier models",
      "Access to image generation",
      "MCP, skills, hooks",
      "Code via Telegram on the go",
    ],
  },
  {
    PlanImage: "",
    Plan: "Pro+",
    PlanColor: "#4FB06D",
    Price: "$30",
    Frequency: "/Month",
    brief: "",
    info: "most popular",
    YearPrice: "$22.5",
    formerYearPrice: "$60",
    button: [
      {
        color: "var(--sixth-white)",
        bg: "var(--sixth-gradient3)",
        text: "get started",
        onClick: () => {
          window.location.href = "https://app.trysixth.com";
        },
      },
    ],
    benefits: [
      "Everything in Pro",
      "5× usage on OpenAI, Claude, Gemini",
      "5× usage on image generation",
      "Priority queue — fastest responses",
      "24/7 dedicated support",
    ],
  },
   {
    PlanImage: "",
    Plan: "Ultra",
    PlanColor: "#4FB06D",
    Price: "$100",
    Frequency: "/Month",
    brief: "",
    YearPrice: "$83",
    formerYearPrice: "$200",
    button: [
      {
        color: "var(--sixth-white)",
        bg: "var(--sixth-gradient3)",
        text: "get started",
        onClick: () => {
          window.location.href = "https://app.trysixth.com";
        },
      },
    ],
    benefits: [
      "Everything in Pro+",
      "20× usage on all models",
      "20× usage on image generation",
      "Early access to newest models",
      "Dedicated infrastructure priority",
      "White-glove onboarding & support",
    ],
  },

];

const lifetimeData = [
  {
    PlanImage: "",
    Plan: "Lifetime",
    PlanColor: "#4FB06D",
    Price: "$2,500",
    Frequency: " one-time",
    brief: "Pay once. Use forever.",
    YearPrice: "$2,500",
    formerYearPrice: "",
    button: [
      {
        color: "var(--sixth-white)",
        bg: "var(--sixth-gradient3)",
        text: "get lifetime",
        onClick: () => {
          window.location.href = "https://app.trysixth.com";
        },
      },
    ],
    benefits: [
      "Unlimited access for life",
      "0 usage cap, use as many tokens as you want a month",
      "Access to all Frontier models, and newest models",
      "No rate limits, ever",
      "Early access to every future model",
      "One payment, no subscription",
    ],
  },
];

const teamsData=[
   {
    PlanImage: "",
    Plan: "Teams",
    PlanColor: "#4FB06D",
    Price: "$32",
    Frequency: "/Month per seat",
    brief: "Let’s talk",
    YearPrice: "$26",
    formerYearPrice: "",
    button: [
      {
        color: "var(--sixth-white)",
        bg: "var(--sixth-gradient3)",
        text: "contact us",
        onClick: () => {
          var body =
            "Dear sixth, I hope this email finds you well. My name is [Your Name], and I am reaching out to discuss [specific topic or purpose]. I believe that a conversation between us could be mutually beneficial. Would you be available for a discussion? If so, I would appreciate it if we could find a suitable time to connect. Please let me know your availability, and I will do my best to accommodate your schedule. Thank you for considering my request. I look forward to hearing from you.Best regards, [Your Full Name] [Your Contact Information]";
          const mailtoLink = `mailto:ope@trysixth.com?subject=schedule Meeting&body=${encodeURIComponent(
            body
          )}`;
          window.location.href = mailtoLink;
        },
      },
    ],
    benefits: [
      "Everything in Pro+ plan",
      "Single sign on",
      "Support up to 4  Team member",
     
      "Fastest response times",
      "Dedicated infrastructure",
      "24/7 dedicated support channel",
      "Feature requests on demand",
    ],
  },

]
